export default "__VITE_ASSET__1fa4c498__"